import {get, post} from '@/ulits/http'
import { upload } from "@/ulits/request";

export function getConfig(params){
  return post('api/generate-images/configs',params)
}

// 生成头像
export function generate (params){
  return post('api/generate-images/paint-template',params)
}

//上传图片

export function undateImg(params) {
  return upload('https://fairy.aibene.cn/api/upload-image',params)
}

// 获取绘画历史

export function imgHistory(params) {
  return post('api/generate-images/history',params)
}

// 私人花夹

export function artGallery(params) {
  return post('api/user/art-gallery', params)
}

// 创作同款
export function again(params) {
  return post('api/generate-images/paint-template-again',params)
}

// 修改用户公开状态
export function editUserStatus(params) {
  return post('api/user/update-info-public-status',params)
}

// 高清图片
export function ampfilyImg (params) {
  return post('api/generate-images/resize',params)
}